<template>
    <div>
        <div v-if="title">
            <van-cell class="title_cell" :title="title" :icon="icon" :style="titleStyle"/>
        </div>

        <div v-if="list && list.length > 0">

            <van-swipe class="van_swipe"
                       indicator-color="#EE0A24"
                       ref="van_swipe"
                       :autoplay="swipe_auto"
                       :duration="duration"
                       @change="swipeChanged"
                       :style="{borderRadius: radius + 'px', height: height, width: width}">
                <div v-for="(item, index) in list" :key="index" >
                    <van-swipe-item v-if="$common.isShowComponent(item)">
                        <div v-if="item.props && typeof (item.props) !== 'undefined'" @click="clickImage(item.props)"
                             :style="{borderRadius: radius + 'px'}">
                            <Wp_image v-if="item.props.img"
                                      :url="item.props.img"
                                      :radius="radius"
                                      :heightPx="height"
                                      :img-gray="imgGray"
                                      style="padding: 2px"
                            ></Wp_image>
                            <Wp_image v-else :heightPx="height" :img-grag="imgGrag"></Wp_image>

                            <div v-if="show_video && index === 0" style="position: absolute; top: 0">
                                <Wp_video_player :width="$common.screenWidth + 'px'"
                                                 :height="$common.screenWidth + 'px'"
                                                 :poster-image="item.props.img"
                                                 :auto-play="show_video"
                                                 :url="video_data.playUrl"
                                                 @onPlayerEnded="onPlayerEnded"
                                ></Wp_video_player>
                                <div style="position: absolute; top: 10px; left: 10px; ">
                                    <van-icon name="cross" size="20" color="#ffffff"
                                              style="background-color: rgba(120,120,120,0.8); border-radius: 15px; width: 30px; height: 30px; padding: 5px"
                                              @click="closeVideo"></van-icon>
                                </div>
                            </div>
                        </div>

                        <div v-else @click="clickImage(item, index)" :style="{borderRadius: radius + 'px'}">
                            <Wp_image v-if="item.img"
                                      :url="item.img"
                                      :radius="radius"
                                      :heightPx="height"
                                      :img-gray="imgGray"
                            ></Wp_image>
                            <Wp_image v-else :heightPx="height" :img-grag="imgGrag"></Wp_image>

                            <div v-if="show_video && index === 0" style="position: absolute; top: 0">
                                <Wp_video_player :poster-image="item.img"
                                                 :auto-play="show_video"
                                                 :url="video_data.playUrl"
                                                 @onPlayerEnded="onPlayerEnded"
                                ></Wp_video_player>
                                <div style="position: absolute; top: 15px; left: 15px; ">
                                    <van-icon name="cross" size="20" color="#ffffff"
                                              style="background-color: rgba(120,120,120,0.8); border-radius: 15px; width: 30px; height: 30px; padding: 5px"
                                              @click="closeVideo"></van-icon>
                                </div>
                            </div>
                        </div>
                    </van-swipe-item>
                </div>
            </van-swipe>
        </div>
        <div v-if="video_data && video_data.playUrl && !show_video"
             :style="{position: 'absolute', width: $common.screenWidth + 'px', top: ($common.screenWidth - 10) + 'px', textAlign: 'center'}">
            <div style="display: inline-flex; background-color: rgba(255,255,255, 0.9); padding: 2px; border-radius: 20px; border: 0.3px solid #d9d9d9"
                 @click="playVideo">
                <van-icon name="play-circle" color="#F65452" size="25"></van-icon>
                <div style="height: 25px; line-height: 25px; margin: 0px 10px">{{video_time}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Wp_image from "./Wp_image";
    import Wp_video_player from "./Wp_video_player";

    export default {
        name: "Wp_img_swipe",
        components: {Wp_video_player, Wp_image},

        props: {
            // imageList:{type: Array},

            icon: {type: String, default: ""},
            title: {type: String, default: ""},
            titleStyle: {type: String, default: ""},
            radius: {type: Number, default: 0},
            autoPlay: {type: Number, default: 5000},
            duration: {type: Number, default: 500},
            list: {type: Array},// list = [{"img": "img_url", ...},{}] // [{component: "", id: "", props:{}}]

            height: {type: String, default: "160px"},
            width: {type: String, default: ""},
            imgGray: {type: Boolean, default: false},
            videoList: {type: Array, default: null},

        },

        data() {
            return {
                image_height: 0,
                datas: null,
                swipe_auto: 5000,
                show_video: false,
                // show_video_btn: false,
                video_data: null,
                video_time: '0',
            }
        },

        created() {

            // if(this.list && this.list.length > 0){
            //     let img_url = this.list[0].props.img;
            //     let img = new Image()
            //     img.onload = ()=>{
            //         this.image_height = img.height;
            //         this.$log("this.image_height = " + this.image_height)
            //     }
            //     img.src = img_url;
            // }
            this.swipe_auto = this.autoPlay;
            if (this.videoList && this.videoList.length > 0) {
                this.video_data = this.videoList[0];
                if (this.video_data && this.video_data.duration) {
                    this.formatVideoTime(this.video_data.duration);
                }
            }
        },

        methods: {
            swipeChanged(index) {
                if (!index) {
                    index = 0;
                }
                //如果swipe切换时，视频正在播放，切换后的index不是0，则关闭视频
                if (this.show_video === true && index !== 0) {
                    setTimeout(() => {
                        this.closeVideo();
                    }, this.duration);
                }
                this.$emit("changeImg", index)
            },

            clickImage(item, index) {
                this.$emit("clickImage", item);

                this.$emit("clickImageRequestIndex", index);
            },

            /**
             * 播放视频
             */
            playVideo() {
                //开始播放前，先将轮播返回到第一个位置
                this.$refs.van_swipe.swipeTo(0);
                this.swipe_auto = 0;

                this.show_video = true;
            },

            /**
             * 关闭视频
             */
            closeVideo() {
                this.show_video = false;
                this.swipe_auto = 5000;
            },

            /**
             * 视频播放完毕
             */
            onPlayerEnded() {
                this.closeVideo();
            },

            /**
             * 格式化视频时间
             * @param _time
             */
            formatVideoTime(_time) {
                // this.video_time
                let time = Number(_time);
                let minite = parseInt(time / 60);
                let second = time - minite * 60;

                let minite_str = minite.toString();
                let second_str = second.toString();
                if (minite_str.length === 1) {
                    minite_str = '0' + minite_str;
                }
                if (second_str.length === 1) {
                    second_str = '0' + second_str;
                }

                this.video_time = minite_str + "'" + second_str + '"';
            }

        }
    }
</script>

<style scoped>
    .title_cell {
        padding: 0px 1px;
        background-color: rgba(0, 0, 0, 0);
    }

    .van_swipe {
        /*height: 160px;*/
        /*border: 1px solid #FFFFFF;*/
        /*background-color: #279fcf;*/
    }


    /deep/ .van-swipe__indicator {
        background-color: #1989fa;
        /*border: 1px solid #1989fa;*/
    }

    /deep/ .van-swipe__indicators {
        bottom: 5px;
    }

    .video_player_btn {

    }
</style>